var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Injectable } from 'angular-ts-decorators';
let UserService = class UserService {
    $http;
    jwt;
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$http'];
    constructor($http) {
        this.$http = $http;
    }
    getUsers(page, page_size, filter, order_criteria, roleIds) {
        let url = '/accounts/getUsers';
        url += '?page=' + page;
        url += '&page_size=' + page_size;
        url += '&filter=' + encodeURIComponent(filter);
        url += '&order_criteria=' + order_criteria;
        if (roleIds?.length) {
            url += '&roleIds=' + encodeURIComponent(roleIds.join(','));
        }
        url += '&hash=' + new Date().getTime();
        return this.$http.get(url).then((res) => res.data);
    }
    getUserHashtable() {
        return this.$http.get('/accounts/getUserHashtable').then((res) => res.data);
    }
    updateUser(model) {
        return this.$http.post('/accounts/update/user', {
            organization: model.organization,
            user: model.user,
            deactivate: model.is_deleted,
            role: model.role,
            account_locked: model.account_locked,
            two_factor_enabled: model.two_factor_enabled,
            note: model.note,
        });
    }
    getUserRolesAndPermissions(userId) {
        return this.$http
            .get('/api/permissions/user/' + userId + '/roles?nocache=' + new Date().getTime())
            .then((res) => res.data);
    }
    getOrgaRolesAndCurrentRole(userId, organizationId) {
        return this.$http
            .get('/admin/getOrgaAndCurrentRoles/' + userId + '/' + organizationId + '?nocache=' + new Date().getTime())
            .then((res) => res.data);
    }
    getAllUserLicenses(userId) {
        return this.$http.get(`/accounts/user/${userId}/licenses`).then((res) => res.data);
    }
    deleteLicenseById(licenseId) {
        return this.$http.delete(`/accounts/user/user-license/${licenseId}`);
    }
    getFieldDefinitionsForUserForSelectedCrm(user_id) {
        return this.$http.get(`/accounts/field-definitions/${user_id}`);
    }
};
UserService = __decorate([
    Injectable('UserService'),
    __metadata("design:paramtypes", [typeof (_a = typeof ng !== "undefined" && ng.IHttpService) === "function" ? _a : Object])
], UserService);
export { UserService };
